import { render, staticRenderFns } from "./ProductFeatures.vue?vue&type=template&id=2bae65e2&scoped=true"
import script from "./ProductFeatures.vue?vue&type=script&lang=js"
export * from "./ProductFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae65e2",
  null
  
)

export default component.exports